import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms'
import { SignaturePadComponent } from '../../commons/signature-pad/signature-pad.component'
import { MatDialog, MatSnackBar } from '@angular/material'
import { Observable } from 'rxjs';
import { LearnerService } from '../../services/learner.service'
@Component({
  selector: 'app-assessment-plan-gym',
  templateUrl: './assessment-plan-gym.component.html',
  styleUrls: ['./assessment-plan-gym.component.scss']
})
export class AssessmentPlanGymComponent implements OnInit {

  @Input('jobId') jobId;
  @Input('learner') singleLearner;
  @Input('assessment') assessmentEdit;

  gymAssessmentPlanForm: FormGroup;
  gymAssessmentDeclarationForm: FormGroup

  user
  learner: boolean
  assessor: boolean
  assessor1: boolean
  assessor2: boolean
  assessor3: boolean
  assessor4: boolean
  assessor5: boolean
  assessor6: boolean
  learnerData
  job
  loading
  isTrainerField: boolean    //field enable and disable for trainer use Varible
  isIqaField: boolean
  isLearnerField: boolean
  isEdit: boolean = false;

  constructor(
    public dialog: MatDialog,
    public _snackBar: MatSnackBar,
    public _learnerService: LearnerService,

  ) { }

  ngOnInit() {

    this.user = JSON.parse(localStorage.getItem("userRoles"));
    console.log('check the cureent users Role', this.user)

    if (this.user && (this.user.isTrainer || this.user.isAdmin)) {
      this.isTrainerField = false;
    }
    else {
      this.isTrainerField = true;
    }

    if (this.user && (this.user.isIQA || this.user.isAdmin)) {
      this.isIqaField = false;
    }
    else {
      this.isIqaField = true;
    }

    if (this.user && (this.user.isLearner || this.user.isAdmin)) {
      this.isLearnerField = false;
    }
    else {
      this.isLearnerField = true;
    }




    if (!this.isEdit)
      this.createForm()



  }


  ngOnChanges(changes: SimpleChanges) {
    console.log("changes in master rail main", changes);
    if (changes.singleLearner && changes.singleLearner.currentValue) {
      // this.singleLearner = changes.learnerData.currentValue
      this.learnerData = changes.singleLearner.currentValue
    }

    if (changes.jobId && changes.jobId.currentValue) {
      this.job = changes.jobId.currentValue
    }


    if (changes.assessmentEdit && changes.assessmentEdit.currentValue) {
      console.log("changes.assessmentPlanEdit.currentValue in master", changes.assessmentEdit.currentValue)
      this.assessmentEdit = changes.assessmentEdit.currentValue
      console.log("assement plan edit data", this.assessmentEdit);

      if (this.assessmentEdit.gymAssessmentDeclarationForm && this.assessmentEdit.gymAssessmentDeclarationForm.learner && this.assessmentEdit.gymAssessmentDeclarationForm.learner != "") {
        this.learner = true
      }
      if (this.assessmentEdit.gymAssessmentDeclarationForm && this.assessmentEdit.gymAssessmentDeclarationForm.assessor && this.assessmentEdit.gymAssessmentDeclarationForm.assessor != "") {
        this.assessor = true
      }
      if (this.assessmentEdit.gymAssessmentDeclarationForm && this.assessmentEdit.gymAssessmentDeclarationForm.assessor1 && this.assessmentEdit.gymAssessmentDeclarationForm.assessor1 != "") {
        this.assessor1 = true
      }
      if (this.assessmentEdit.gymAssessmentDeclarationForm && this.assessmentEdit.gymAssessmentDeclarationForm.assessor2 && this.assessmentEdit.gymAssessmentDeclarationForm.assessor2 != "") {
        this.assessor2 = true
      }
      if (this.assessmentEdit.gymAssessmentDeclarationForm && this.assessmentEdit.gymAssessmentDeclarationForm.assessor3 && this.assessmentEdit.gymAssessmentDeclarationForm.assessor3 != "") {
        this.assessor3 = true
      }
      if (this.assessmentEdit.gymAssessmentDeclarationForm && this.assessmentEdit.gymAssessmentDeclarationForm.assessor4 && this.assessmentEdit.gymAssessmentDeclarationForm.assessor4 != "") {
        this.assessor4 = true
      }
      this.isEdit = true
      this.createForm(this.assessmentEdit)

    }
    else{
      this.createForm()
    }
  }



  /** *******************************************************************
   * create Form Data ***************************************************
   * 
   * *****************************************************************************
   */


  createForm(data?) {
    console.log('check this disabled or not checked ', this.isTrainerField)
    console.log('data get in createForm method', data)
    this.gymAssessmentPlanForm = new FormGroup({
      date1: new FormControl({ value: (data && data.gymAssessmentPlanForm) ? data.gymAssessmentPlanForm.date1 : '', disabled: this.isTrainerField }),
      claiming1: new FormControl({ value: (data && data.gymAssessmentPlanForm) ? data.gymAssessmentPlanForm.claiming1 : '', disabled: this.isTrainerField }),
      date2: new FormControl({ value: (data && data.gymAssessmentPlanForm) ? data.gymAssessmentPlanForm.date2 : '', disabled: this.isTrainerField }),
      iv1: new FormControl({ value: (data && data.gymAssessmentPlanForm) ? data.gymAssessmentPlanForm.iv1 : '', disabled: this.isIqaField }),

      date3: new FormControl({ value: (data && data.gymAssessmentPlanForm) ? data.gymAssessmentPlanForm.date3 : '', disabled: this.isTrainerField }),
      claiming2: new FormControl({ value: (data && data.gymAssessmentPlanForm) ? data.gymAssessmentPlanForm.claiming2 : '', disabled: this.isTrainerField }),
      date4: new FormControl({ value: (data && data.gymAssessmentPlanForm) ? data.gymAssessmentPlanForm.date4 : '', disabled: this.isTrainerField }),
      iv2: new FormControl({ value: (data && data.gymAssessmentPlanForm) ? data.gymAssessmentPlanForm.iv2 : '', disabled: this.isIqaField }),

      date5: new FormControl({ value: (data && data.gymAssessmentPlanForm) ? data.gymAssessmentPlanForm.date5 : '', disabled: this.isTrainerField }),
      claiming3: new FormControl({ value: (data && data.gymAssessmentPlanForm) ? data.gymAssessmentPlanForm.claiming3 : '', disabled: this.isTrainerField }),
      date6: new FormControl({ value: (data && data.gymAssessmentPlanForm) ? data.gymAssessmentPlanForm.date6 : '', disabled: this.isTrainerField }),
      iv3: new FormControl({ value: (data && data.gymAssessmentPlanForm) ? data.gymAssessmentPlanForm.iv3 : '', disabled: this.isIqaField }),

      date7: new FormControl({ value: (data && data.gymAssessmentPlanForm) ? data.gymAssessmentPlanForm.date7 : '', disabled: this.isTrainerField }),
      claiming4: new FormControl({ value: (data && data.gymAssessmentPlanForm) ? data.gymAssessmentPlanForm.claiming4 : '', disabled: this.isTrainerField }),
      date8: new FormControl({ value: (data && data.gymAssessmentPlanForm) ? data.gymAssessmentPlanForm.date8 : '', disabled: this.isTrainerField }),
      iv4: new FormControl({ value: (data && data.gymAssessmentPlanForm) ? data.gymAssessmentPlanForm.iv4 : '', disabled: this.isIqaField }),

      date9: new FormControl({ value: (data && data.gymAssessmentPlanForm) ? data.gymAssessmentPlanForm.date9 : '', disabled: this.isTrainerField }),
      claiming5: new FormControl({ value: (data && data.gymAssessmentPlanForm) ? data.gymAssessmentPlanForm.claiming5 : '', disabled: this.isTrainerField }),
      date10: new FormControl({ value: (data && data.gymAssessmentPlanForm) ? data.gymAssessmentPlanForm.date10 : '', disabled: this.isTrainerField }),
      iv5: new FormControl({ value: (data && data.gymAssessmentPlanForm) ? data.gymAssessmentPlanForm.iv5 : '', disabled: this.isIqaField }),

      date11: new FormControl({ value: (data && data.gymAssessmentPlanForm) ? data.gymAssessmentPlanForm.date11 : '', disabled: this.isTrainerField }),
      claiming6: new FormControl({ value: (data && data.gymAssessmentPlanForm) ? data.gymAssessmentPlanForm.claiming6 : '', disabled: this.isTrainerField }),
      date12: new FormControl({ value: (data && data.gymAssessmentPlanForm) ? data.gymAssessmentPlanForm.date12 : '', disabled: this.isTrainerField }),
      iv6: new FormControl({ value: (data && data.gymAssessmentPlanForm) ? data.gymAssessmentPlanForm.iv6 : '', disabled: this.isIqaField }),

      date13: new FormControl({ value: (data && data.gymAssessmentPlanForm) ? data.gymAssessmentPlanForm.date13 : '', disabled: this.isTrainerField }),
      claiming7: new FormControl({ value: (data && data.gymAssessmentPlanForm) ? data.gymAssessmentPlanForm.claiming7 : '', disabled: this.isTrainerField }),
      date14: new FormControl({ value: (data && data.gymAssessmentPlanForm) ? data.gymAssessmentPlanForm.date14 : '', disabled: this.isTrainerField }),
      iv7: new FormControl({ value: (data && data.gymAssessmentPlanForm) ? data.gymAssessmentPlanForm.iv7 : '', disabled: this.isIqaField }),


      date15: new FormControl({ value: (data && data.gymAssessmentPlanForm) ? data.gymAssessmentPlanForm.date15 : '', disabled: this.isTrainerField }),
      claiming8: new FormControl({ value: (data && data.gymAssessmentPlanForm) ? data.gymAssessmentPlanForm.claiming8 : '', disabled: this.isTrainerField }),
      date16: new FormControl({ value: (data && data.gymAssessmentPlanForm) ? data.gymAssessmentPlanForm.date16 : '', disabled: this.isTrainerField }),
      iv8: new FormControl({ value: (data && data.gymAssessmentPlanForm) ? data.gymAssessmentPlanForm.iv8 : '', disabled: this.isIqaField }),

      date17: new FormControl({ value: (data && data.gymAssessmentPlanForm) ? data.gymAssessmentPlanForm.date17 : '', disabled: this.isTrainerField }),
      claiming9: new FormControl({ value: (data && data.gymAssessmentPlanForm) ? data.gymAssessmentPlanForm.claiming9 : '', disabled: this.isTrainerField }),
      date18: new FormControl({ value: (data && data.gymAssessmentPlanForm) ? data.gymAssessmentPlanForm.date18 : '', disabled: this.isTrainerField }),
      iv9: new FormControl({ value: (data && data.gymAssessmentPlanForm) ? data.gymAssessmentPlanForm.iv9 : '', disabled: this.isIqaField }),

      date19: new FormControl({ value: (data && data.gymAssessmentPlanForm) ? data.gymAssessmentPlanForm.date19 : '', disabled: this.isTrainerField }),
      claiming10: new FormControl({ value: (data && data.gymAssessmentPlanForm) ? data.gymAssessmentPlanForm.claiming10 : '', disabled: this.isTrainerField }),
      date20: new FormControl({ value: (data && data.gymAssessmentPlanForm) ? data.gymAssessmentPlanForm.date20 : '', disabled: this.isTrainerField }),
      iv10: new FormControl({ value: (data && data.gymAssessmentPlanForm) ? data.gymAssessmentPlanForm.iv10 : '', disabled: this.isIqaField }),

      date21: new FormControl({ value: (data && data.gymAssessmentPlanForm) ? data.gymAssessmentPlanForm.date21 : '', disabled: this.isTrainerField }),
      claiming11: new FormControl({ value: (data && data.gymAssessmentPlanForm) ? data.gymAssessmentPlanForm.claiming11 : '', disabled: this.isTrainerField }),
      date22: new FormControl({ value: (data && data.gymAssessmentPlanForm) ? data.gymAssessmentPlanForm.date22 : '', disabled: this.isTrainerField }),
      iv11: new FormControl({ value: (data && data.gymAssessmentPlanForm) ? data.gymAssessmentPlanForm.iv11 : '', disabled: this.isIqaField }),

      date23: new FormControl({ value: (data && data.gymAssessmentPlanForm) ? data.gymAssessmentPlanForm.date23 : '', disabled: this.isTrainerField }),
      claiming12: new FormControl({ value: (data && data.gymAssessmentPlanForm) ? data.gymAssessmentPlanForm.claiming12 : '', disabled: this.isTrainerField }),
      date24: new FormControl({ value: (data && data.gymAssessmentPlanForm) ? data.gymAssessmentPlanForm.date24 : '', disabled: this.isTrainerField }),
      iv12: new FormControl({ value: (data && data.gymAssessmentPlanForm) ? data.gymAssessmentPlanForm.iv12 : '', disabled: this.isIqaField }),
    })

    this.gymAssessmentDeclarationForm = new FormGroup({
      name1: new FormControl((data && data.gymAssessmentDeclarationForm) ? data.gymAssessmentDeclarationForm.name1 : ''),
      date1: new FormControl((data && data.gymAssessmentDeclarationForm) ? data.gymAssessmentDeclarationForm.date1 : ''),
      learner: new FormControl((data && data.gymAssessmentDeclarationForm) ? data.gymAssessmentDeclarationForm.learner : ''),

      name2: new FormControl((data && data.gymAssessmentDeclarationForm) ? data.gymAssessmentDeclarationForm.name2 : ''),
      date2: new FormControl((data && data.gymAssessmentDeclarationForm) ? data.gymAssessmentDeclarationForm.date2 : ''),
      assessor: new FormControl((data && data.gymAssessmentDeclarationForm) ? data.gymAssessmentDeclarationForm.assessor : ''),

      name3: new FormControl((data && data.gymAssessmentDeclarationForm) ? data.gymAssessmentDeclarationForm.name3 : ''),
      date3: new FormControl((data && data.gymAssessmentDeclarationForm) ? data.gymAssessmentDeclarationForm.date3 : ''),
      assessor1: new FormControl((data && data.gymAssessmentDeclarationForm) ? data.gymAssessmentDeclarationForm.assessor1 : ''),

      name4: new FormControl((data && data.gymAssessmentDeclarationForm) ? data.gymAssessmentDeclarationForm.name4 : ''),
      date4: new FormControl((data && data.gymAssessmentDeclarationForm) ? data.gymAssessmentDeclarationForm.date4 : ''),
      assessor2: new FormControl((data && data.gymAssessmentDeclarationForm) ? data.gymAssessmentDeclarationForm.assessor2 : ''),

      name5: new FormControl((data && data.gymAssessmentDeclarationForm) ? data.gymAssessmentDeclarationForm.name5 : ''),
      date5: new FormControl((data && data.gymAssessmentDeclarationForm) ? data.gymAssessmentDeclarationForm.date5 : ''),
      assessor3: new FormControl((data && data.gymAssessmentDeclarationForm) ? data.gymAssessmentDeclarationForm.assessor3 : ''),

      name6: new FormControl((data && data.gymAssessmentDeclarationForm) ? data.gymAssessmentDeclarationForm.name6 : ''),
      date6: new FormControl((data && data.gymAssessmentDeclarationForm) ? data.gymAssessmentDeclarationForm.date6 : ''),
      assessor4: new FormControl((data && data.gymAssessmentDeclarationForm) ? data.gymAssessmentDeclarationForm.assessor4 : ''),
    })



    // if (this.user && (this.user.isTrainer || this.user.isMp || this.user.isClient)) {
    //   this.gymAssessmentDeclarationForm.controls['name1'].disable()
    //   this.gymAssessmentDeclarationForm.controls['date1'].disable()
    //   this.gymAssessmentDeclarationForm.controls['learner'].disable()

    // }


    // if (this.user && (this.user.isLearner)) {
    //   this.gymAssessmentPlanForm.disable()
    //   this.gymAssessmentDeclarationForm.disable()
    //   this.gymAssessmentDeclarationForm.controls['name1'].enable()
    //   this.gymAssessmentDeclarationForm.controls['date1'].enable()
    //   this.gymAssessmentDeclarationForm.controls['learner'].enable()
    // }



  }




  /** *****************************************************************
   * Add Signature Section ********************************************
   * 
   * **************************************************************************
   */

  addSignature(fomrControl) {


    this.openDialog(SignaturePadComponent).subscribe((data) => {
      console.log("data of sign", data);
      if (data == undefined) return

      let sign = data




      if (fomrControl == 'learner') {
        this.learner = true
        this.gymAssessmentDeclarationForm.patchValue({
          learner: sign
        })
      }
      if (fomrControl == 'assessor') {
        this.assessor = true
        this.gymAssessmentDeclarationForm.patchValue({
          assessor: sign
        })
      }

      if (fomrControl == 'assessor1') {
        this.assessor1 = true
        this.gymAssessmentDeclarationForm.patchValue({
          assessor1: sign
        })
      }

      if (fomrControl == 'assessor2') {
        this.assessor2 = true
        this.gymAssessmentDeclarationForm.patchValue({
          assessor2: sign
        })
      }

      if (fomrControl == 'assessor3') {
        this.assessor3 = true
        this.gymAssessmentDeclarationForm.patchValue({
          assessor3: sign
        })
      }

      if (fomrControl == 'assessor4') {
        this.assessor4 = true
        this.gymAssessmentDeclarationForm.patchValue({
          assessor4: sign
        })
      }


    })

  }

  /**********************************************************************
   * utility Function here **************************************************
   * 
   * **************************************************************************
   */


  handleSnackBar(data) {
    this.openSnackBar(data.msg, data.button);
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }



  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, {
      data, maxWidth: '100vw',
      maxHeight: '100vh',
      height: '100%',
      width: '100%'
    });
    return dialogRef.afterClosed();
  }

  onChangeEvent(value, formGroup, formControl) {
    console.log("value, formControl, formGroup", value, formControl, formGroup);

    if (formGroup == 'gymAssessmentPlanForm')
      this.gymAssessmentPlanForm.get(formControl).setValue(value);

    else if (formGroup == 'gymAssessmentDeclarationForm')
      this.gymAssessmentDeclarationForm.get(formControl).setValue(value);

  }


  submitAssessmentPlan() {

    console.log('this form current value............', this.gymAssessmentDeclarationForm.value)
    console.log('learner ID', this.learnerData._id)
    console.log('this jobid', this.job)

    let data = {
      learnerId: this.learnerData._id,
      jobId: this.jobId,
      version: true,
      details: {
        gymAssessmentPlanForm: this.gymAssessmentPlanForm.value,
        gymAssessmentDeclarationForm: this.gymAssessmentDeclarationForm.value
      }
    }
    console.log("this._learnerService.submitPolicy(data) in assessmant Plan", data)
    this._learnerService.submitPolicy(data).subscribe(res => {
      console.log('Policy res', res);
      this.handleSnackBar({ msg: "Data submitted successfully!", button: "Ok" });
      this.loading = false
    }, (err) => {
      this.loading = false
      console.log("policy not accepted", err)
    })



  }

}
